/** ... */
export const devSubscriptionKey = 'b6bc44ad5b2747eaad3ea36573dd9db4';
